import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Label } from 'semantic-ui-react';

import BlockLabel from './block-label';

const leftAlign = {
  textAlign: 'left',
  margin: 3,
  'background': '#9ad2ff'
};

const padding20 = {
  padding: 20,
  height: 150,
};

const HashtagsAndMentions = props => {
  const { profile } = props;
  const instagramHashtags = _.take(_.get(profile, 'instagramHashtags'), 6);
  return (
    <div style={padding20}>
      {_.map(instagramHashtags, tag => (
        <Label style={leftAlign}>{_.get(tag, 'hashtag')}</Label>
      ))}
      <BlockLabel label="Top Hashtags" />
    </div>
  );
};

HashtagsAndMentions.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default HashtagsAndMentions;



// WEBPACK FOOTER //
// ./src/containers/summary/components/hashtags-and-mentions.js